import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="timezone"
export default class extends Controller {
  connect = () => {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
    const match = Array.from(this.element.options).find(o => o.value === tz)
    if (match) match.selected = true
  }
}
